// Mirrors backend OnlineWebinar.Grains.Interfaces.Webinar.Models.SpeakerStatus order/values exactly.
export enum SpeakerStatus {
    Offline = 0, // was connected, now disconnected
    SettingUp = 1, // choosing/testing camera+mic
    AwaitingAdmission = 2, // (Phase 2+) held until host admits
    Connecting = 3, // (Phase 2) establishing WebRTC to broadcaster/SFU
    NotReady = 4, // devices OK, "ready" toggle OFF
    Ready = 5, // speaker toggled "I'm ready to be added"
    GoingLive = 6, // (Phase 2) 3-5s go-live countdown
    OnAir = 7, // (Phase 2) live + published
    Error = 8, // device/connection problem
    Banned = 9 // (Phase 3+) barred; appended last
}

// Mirrors backend OnlineWebinar.Grains.Interfaces.Webinar.Models.SpeakerStatusInfo.
export interface SpeakerStatusInfo {
    participantId: string;
    status: SpeakerStatus;
}
